import React, { Component } from 'react'
import { connect } from 'react-redux';
import '../../App.css';

import List from '@material-ui/core/List';

import DialogAction from '../../componets/DialogAction.jsx';
import DialogPanel from '../../componets/DialogPanel.jsx';

import * as CurrencyActions from '../../actions/Actions_CurrencyManager';


import CurrencyRateCard from './CurrencyRateCard';
import CurrencyRateListPanel from './CurrencyRateListPanel';
import { init_currencyRate } from '../../constant/initState/initCurrency';

import { InitWaitingTime, SetStateWithTime, SetStateWithObject } from '../../common/SetTime.js';

let CurrencyRateList = [];
let waitingTime = true;
const _height = (window.innerHeight - 130);

class CurrencyRateManage extends Component {
    state = { isLoading: true, msgError: undefined, dialogType: undefined, }
    constructor(props) {
        let error = null;
        super(props);
        this.state = {
            CurrencyInfo: undefined,
            oldCurrencyInfo: null,
            isCreate: false,
            isEdit: false,
            isView: false,
        }
        this.props.getAPICurrencyRateList({ num_limit: 10 });

    }

    componentWillReceiveProps(nextProps) {
        // console.log('[ componentWillReceiveProps(nextProps) : ]', nextProps)
        const { CurrencyManager } = nextProps;
        if (!!CurrencyManager) {

            const { actions, data } = CurrencyManager.CURRENCY_REDUCER;

            switch (actions) {
                case CurrencyActions.GET_CURRENCY_RATE_SUCCESS:
                    {
                        CurrencyRateList = data.result;
                        SetStateWithTime(this, waitingTime);
                    } break;
                case CurrencyActions.GET_CURRENCY_RATE_FAILURE:
                    {
                        SetStateWithTime(this, waitingTime);
                    } break;
            }
        }
    }

    render() {
        const { isLoading, isCreate, isCreateRate } = this.state;
        return (
            <div className="App">
                {(isCreate) && <DialogAction Active={isCreate} OnClose={this.onClosePanel} AcrionCom={this.createCurrencyRate()} />}
                {(isLoading) && <DialogPanel Active={isLoading} />}
                <List style={{ width: '100%', position: 'relative', overflow: 'auto' }}>
                    <div style={{ display: 'inline-block' }}>
                        {this.contentPanel()}
                    </div>
                </List>
            </div>
        )
    }
    contentPanel() {
        return (
            <div style={{ width: '100%', maxWidth: '1024px', }}>
                <CurrencyRateListPanel
                    CurrencyRateList={CurrencyRateList}
                    CreatePanel={this.onCreatePanel(this.state.isCreate)}
                    EditInfo={this.editPanel()}
                    ViewInfo={this.viewInfo()} />
            </div>)
    }
    createCurrencyRate = () => {
        const { isEdit, CurrencyInfo, oldCurrencyInfo, isView } = this.state;
        return (
            <CurrencyRateCard
                CurrencyRateList={CurrencyRateList}
                onChangeLanguage={this.onChangeLanguage}
                isEdit={isEdit}
                isView={isView}
                CurrencyInfo={CurrencyInfo}
                oldCurrencyInfo={oldCurrencyInfo}
                onClosePanel={this.onClosePanel}
            />
        )
    }

    onCreatePanel = (_isActive) => () => (this.setState({
        isCreate: !_isActive, isEdit: false, isView: false,
        oldCurrencyInfo: { ...init_currencyRate }, CurrencyInfo: { ...init_currencyRate },
    }));

    onClosePanel = () => (this.setState({ isCreate: false, isEdit: false, isView: false, CurrencyInfo: undefined, }));
    onCloseDialog = () => (this.setState({ isLoading: false, msgError: undefined, dialogType: undefined }));

    onChangeLanguage = (_language) => {
        const { page } = CurrencyRateList;
        this.props.getAPICurrencyRateList({ page: page, num_limit: 10, language: _language });
    }

    editPanel = () => (CurrencyInfo) => {
        this.setState({
            isCreateRate: true,
            isCreate: true,
            isEdit: true,
            CurrencyInfo,
            oldCurrencyInfo: CurrencyInfo,
        })
    }

    viewInfo = () => (CurrencyInfo) => {
        this.setState({
            isCreateRate: true,
            isCreate: true,
            isView: true,
            CurrencyInfo,
            oldCurrencyInfo: CurrencyInfo,
        })
    }

}
function mapStateToProps(state, ownProps) {
    return { ...state };
}

function mapDispatchToProps(dispatch) {
    return {
        getAPICurrencyRateList: (_keyword, _filter) => {
            InitWaitingTime();
            dispatch(CurrencyActions.getCurrencyRateList(_keyword, _filter));
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CurrencyRateManage);